<template></template>

<script>
import db from "../../js/db";
import mixins from "../../js/mixins";
import * as ExcelJS from "exceljs";
import { downloadWorkbook } from "../../js/excel";
import Config from "../../../config-app/config";
import * as Utils from "../../js/utils";

export default {
  name: "swal-download-rose",
  mixins: [mixins],
  components: {},
  mounted() {
    db.on("promptDownloadRose", this.open);
  },
  destroyed() {
    db.off("promptDownloadRose", this.open);
  },
  computed: {},
  methods: {
    open() {
      Swal.fire({
        title: "Download rose",
        html:
          '<div style="text-align: center;color: #607D8B;">' +
          "Scarica rose in Excel" +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Download",
        cancelButtonText: "Annulla",
      }).then((result) => {
        if (result.isConfirmed == true) {
          this.downloadToExcel();
        }
      });
    },
    downloadToExcel() {
      const numSquadre = _.size(this.asta_squadre);
      const filename = "Rose " + this.asta_info.name;

      const data = this.createData();

      const numCols = _.size(data[0]);
      const numColPerSquadra = numCols / numSquadre;

      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet("Rose");

      ws.addRows(data);

      ws.columns.slice(0, numCols).forEach((column, columnNumber) => {
        // horizontal: 'center'
        column.alignment = { horizontal: "center" };
        // border
        if ((columnNumber + 1) % numColPerSquadra === 0) {
          column.border = {
            right: { style: "thin" },
          };
        }
      });

      // merge
      let startColumn = 1;
      let endColumn = numColPerSquadra - 1;
      for (let i = 0; i < numSquadre; i++) {
        ws.mergeCells(1, startColumn, 1, endColumn);
        ws.getCell(1, endColumn).font = { bold: true };
        startColumn += numColPerSquadra;
        endColumn = startColumn - 1 + (numColPerSquadra - 1);
      }

      // Generate an Excel file
      downloadWorkbook(wb, filename)
        .catch((error) => {
          console.log("Error occurred:", error);
        });
    },

    ruoliMantraReduce(mantra_ids) {
      const convertedElements = mantra_ids.map(this.ruoloMantra);
      const result = convertedElements.join(", ");
      return result;
    },
    createData() {
      let squads = [];
      _.each(this.asta_squadre, (squadra) => {
        // build rosa
        const rosa = _.map(squadra.calciatori || [], (item, calciatore_id) => {
          const calciatore = this.calciatori[calciatore_id];
          // console.log('calciatore', calciatore)
          return {
            ...calciatore,
            prezzo: item.p,
            ruolo: this.classic
              ? this.ruolo(calciatore.ID_Ruolo)
              : this.ruoliMantraReduce(calciatore.mantra_ids),
          };
        });

        // sort rosa
        const rosaSorted = _.orderBy(
          rosa,
          ["ID_Ruolo", "prezzo", "quotazione", "calciatore"],
          ["asc", "desc", "desc", "asc"]
        );

        // output
        let squad = [[squadra.name, "", "", squadra.crediti]];
        _.each(rosaSorted, (calciatore) => {
          const nomeCalciatore = calciatore.calciatore;
          const ruolo = calciatore.ruolo;
          const prezzo = calciatore.prezzo;
          const nomeClub = calciatore.nomeClub;
          squad.push([ruolo, nomeCalciatore, nomeClub, prezzo]);
        });

        squads.push(squad);
      });

      // concatena squads
      return squads.reduce((result, current) => {
        return result.map((row, i) => row.concat(current[i]));
      });
    },
  },
};
</script>
<style></style>
